<template>
  <v-content>
    <div
      class="auth-wrap d-flex fill-height align-center justify-center v-image__image--cover"
    >
      <div class="auth-holder d-flex elevation-5 align-stretch justify-center">
        <v-row class="align-stretch justify-center" no-gutters>
          <v-col
            cols="12"
            md="6"
            class="auth-bg-image d-flex align-center justify-center"
            style="min-height: 350px"
          >
            <v-btn
              depressed
              x-large
              href="https://www.youtube.com/watch?v=YF4EXPmff7o"
              class="py-10 px-12 rounded-full title font-weight-bold"
              target="_blank"
            >
              <v-icon class="mr-5">$play</v-icon>
              Watch tutorial
            </v-btn>
          </v-col>
          <v-col class="d-flex align-center justify-center" cols="12" md="6">
            <transition name="auth-transition" mode="out-in">
              <router-view
                id="PageWrapper"
                ref="content"
                class="container px-5 px-md-16 py-5 py-md-15 d-flex flex-column flex-fill wrap align-stretch justify-center"
                :key="$route.fullPath"
              />
            </transition>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-content>
</template>

<script>
import '@assets/scss/auth.scss';

export default {
  name: 'Auth',
};
</script>
